import { useQuery } from "@apollo/client"
import { UspCarouselData } from "../../components/contentful/UspCarouselTwo"
import { GET_USP_CAROUSEL } from "../../graphql/queries/getUspCarousel"
import { client } from "../../graphql/contentful/client"

export function useUspCarousel(id: string) {
  const { data, loading, error } = useQuery<{ uspCarousel: UspCarouselData }, { id: string }>(GET_USP_CAROUSEL, {
    client: client,
    variables: { id },
  })

  return { data: data?.uspCarousel, loading, error }
}
